import { useState, type FormEvent } from 'react';

const FORM_ID = 'dahbp6joh653ivfvnqpg';
const SUBMIT_ADDR = 'https://readdy.ai/api/form/dahbp6joh653ivfvnqpg';

export default function NewsletterForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formEl = event.currentTarget;
    const payload = new FormData(formEl);

    const guard = String(payload.get('contact_alt') ?? '').trim();
    if (guard) {
      setStatus('success');
      setFormError('');
      return;
    }
    payload.delete('contact_alt');

    setStatus('loading');
    setFormError('');

    const body = new URLSearchParams();
    payload.forEach((value, key) => {
      body.append(key, String(value));
    });

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      const isSpam = serverMsg.toLowerCase().includes('spam');
      const ok = response.ok && parsed?.code === 'OK' && !isSpam;

      if (ok) {
        setStatus('success');
        formEl.reset();
      } else {
        setStatus('error');
        setFormError(isSpam ? '提交未通过校验，请检查后重试。' : serverMsg || '提交失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setFormError('网络异常，请稍后再试。');
    }
  };

  return (
    <form
      id="newsletter-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full max-w-md"
      aria-label="瓜料情报订阅"
    >
      <div className="flex flex-col sm:flex-row gap-3">
        <label className="flex-1">
          <span className="sr-only">邮箱地址</span>
          <input
            type="email"
            name="email"
            required
            placeholder="留下邮箱，收本周新专题"
            className="w-full h-12 px-4 rounded-md border border-background-300 bg-background-50 text-sm label-font text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400"
          />
        </label>
        <input
          type="text"
          name="contact_alt"
          className="form-field-guard"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          className="h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm label-font whitespace-nowrap hover:bg-primary-600 transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer"
        >
          {status === 'loading' ? '提交中…' : '订阅更新'}
        </button>
      </div>

      {status === 'success' && (
        <p className="mt-3 text-sm text-secondary-700 label-font">
          <i className="ri-checkbox-circle-line mr-1"></i>
          订阅成功，之后有新的专题会通知你。
        </p>
      )}
      {status === 'error' && formError && (
        <p className="mt-3 text-sm text-primary-700 label-font">
          <i className="ri-error-warning-line mr-1"></i>
          {formError}
        </p>
      )}
      {status === 'idle' && (
        <p className="mt-3 text-xs text-foreground-500 label-font">
          仅发送内容更新提醒，可随时取消。表单编号：{FORM_ID}
        </p>
      )}
    </form>
  );
}